import { render, staticRenderFns } from "./student_select.vue?vue&type=template&id=19a51ca6&scoped=true&"
import script from "./student_select.vue?vue&type=script&lang=js&"
export * from "./student_select.vue?vue&type=script&lang=js&"
import style0 from "./student_select.vue?vue&type=style&index=0&id=19a51ca6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a51ca6",
  null
  
)

export default component.exports